define("shared/components/shared/table-analytics", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"@ember/component/template-only",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{concat (if @fullWidth "u--col__12" "u--col__6") " u--p__tb__xs"}} ...attributes>
    <p class="u--text--md u--text--bold u--p__l__xs u--m__b__0">
      {{t "profile_categorization.reports.shared.top_hashtags"}}
    </p>
    
    {{#if @header}}
      <p class="u--p__l__xs u--m__b__0 {{if @isCapitalized "u--text--capitalize"}}">
        {{@header}}
      </p>
    {{/if}}
  
    <hr class="u--m__t u--m__b__0">
    
    <ul class="tSC--result__ul qa--categorize_reports_hashtag_content">
      {{#each @rows as |value|}}
        <li class="tSC--result__li u--ellipsis">{{value}}</li>
      {{/each}}
    </ul>
  
  </div>
  */
  {
    "id": "ggQSeXXx",
    "block": "[[[11,0],[16,0,[28,[37,0],[[52,[30,1],\"u--col__12\",\"u--col__6\"],\" u--p__tb__xs\"],null]],[17,2],[12],[1,\"\\n  \"],[10,2],[14,0,\"u--text--md u--text--bold u--p__l__xs u--m__b__0\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"profile_categorization.reports.shared.top_hashtags\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \\n\"],[41,[30,3],[[[1,\"    \"],[10,2],[15,0,[29,[\"u--p__l__xs u--m__b__0 \",[52,[30,4],\"u--text--capitalize\"]]]],[12],[1,\"\\n      \"],[1,[30,3]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n  \"],[10,\"hr\"],[14,0,\"u--m__t u--m__b__0\"],[12],[13],[1,\"\\n  \\n  \"],[10,\"ul\"],[14,0,\"tSC--result__ul qa--categorize_reports_hashtag_content\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,5]],null]],null],null,[[[1,\"      \"],[10,\"li\"],[14,0,\"tSC--result__li u--ellipsis\"],[12],[1,[30,6]],[13],[1,\"\\n\"]],[6]],null],[1,\"  \"],[13],[1,\"\\n\\n\"],[13]],[\"@fullWidth\",\"&attrs\",\"@header\",\"@isCapitalized\",\"@rows\",\"value\"],false,[\"concat\",\"if\",\"t\",\"each\",\"-track-array\"]]",
    "moduleName": "shared/components/shared/table-analytics.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});